import { Button, Text } from "@/components";
import { FaArrowRight } from "react-icons/fa6";
import { ReactComponent as BestValueSvg } from "@/assets/svg/best-value.svg";

export const PricingPlans = () => {
  return (
    <div className="container mx-auto">
      <div className="mx-auto flex flex-col gap-24">
        {[
          {
            name: "White Glove",
            id: "white-glove",
            title: (
              <Text.Heading
                size="sm"
                className="text-white md:px-[100px] text-center"
              >
                <span>
                  White Glove&nbsp;
                  <span className="text-secondary">Concierge Service</span>
                </span>
              </Text.Heading>
            ),
            description: (
              <>
                Effortlessly manage your cap table via email. Simply send us a
                request, and we'll handle the rest.
                <br /> This gives you more time to focus on growing your
                business while saving you thousands in legal <br />
                fees. Paid yearly. Cap table & concierge onboarding included.
                <br />
                <br />
                <span className="text-secondary">Paid yearly.</span>&nbsp;Cap
                table & concierge onboarding included.
              </>
            ),
            tiers: [
              {
                title: "Launch",
                description: "For companies that have raised up to $1M",
                price: 2000,
              },
              {
                title: "Growth",
                description: "For companies that have raised $1M-3M+",
                price: 3000,
              },
              {
                title: "Scale",
                description: "For companies that have raised $3M+",
                price: 4000,
              },
            ],
          },
          {
            name: "409a Valuations",
            id: "f409a",
            title: (
              <Text.Heading
                size="sm"
                className="text-white md:px-[100px] text-center"
              >
                <span>
                  <span className="text-secondary">409A&nbsp;</span>
                  Valuations
                </span>
              </Text.Heading>
            ),
            description: (
              <>
                T12's streamlined 409a solution is designed to save you time.
                Leveraging data directly from your <br />
                cap table, we'll get your next 409a completed quickly and easily
                so you can go back to building.
                <br />
                <br />
                <span className="text-secondary">Bespoke</span>&nbsp;Cap table
                not included.
              </>
            ),
            tiers: [
              {
                title: "Launch",
                description: "For companies that have raised up to $1M",
                price: 2000,
              },
              {
                title: "Growth",
                description: "For companies that have raised $1M-3M+",
                price: 3000,
              },
              {
                title: "Scale",
                description: "For companies that have raised $3M+",
                price: 4000,
              },
            ],
          },
          {
            isPopular: true,
            name: "White Glove + 409a Valuations",
            id: "white-glove-f409a",
            title: (
              <Text.Heading
                size="sm"
                className="text-white md:px-[100px] text-center"
              >
                <span>
                  <span className="text-secondary">White Glove&nbsp;</span>+
                  409a Valuations
                </span>
              </Text.Heading>
            ),
            description: (
              <>
                Save $500 on your 409a valuation every year.
                <br />
                <br />
                <span className="text-secondary">Paid yearly.&nbsp;</span>
                White glove concierge service, cap table, & onboarding included.
              </>
            ),
            tiers: [
              {
                title: "Launch",
                description: "For companies that have raised up to $1M",
                price: 3500,
              },
              {
                title: "Growth",
                description: "For companies that have raised $1M-3M+",
                price: 5500,
              },
              {
                title: "Scale",
                description: "For companies that have raised $3M+",
                price: 7500,
              },
            ],
          },
        ].map(({ title, description, tiers, name, id, isPopular }, pIdx) => {
          return (
            <div key={pIdx} className="flex flex-col gap-4">
              {!!isPopular && (
                <div className="flex items-center justify-center">
                  <BestValueSvg />
                </div>
              )}

              <div className="flex flex-col gap-10 pb-16 border-b border-b-[#7b7b7b]">
                <div className="flex flex-col gap-4">
                  {title}

                  <div className="text-xl text-center">{description}</div>
                </div>

                <div className="grid md:grid-cols-3 gap-4">
                  {tiers.map((tier, tIdx) => (
                    <div
                      key={tIdx}
                      className="p-4 md:px-6 md:py-5 flex flex-col gap-2 md:gap-4 border border-secondary rounded-xl"
                    >
                      <div className="text-xl md:text-2xl text-white">{tier.title}</div>
                      <div className="">{tier.description}</div>
                      <div className="text-2xl md:text-4xl text-white font-bold">
                        ${tier.price.toLocaleString()}
                        <span className="text-xl text-secondary ml-1 md:ml-2">yr</span>
                      </div>
                    </div>
                  ))}
                </div>

                <Button
                  className="flex items-center justify-center gap-2 md:px-12 py-5 text-xl md:text-2xl"
                  href={`/sign-up?product=${id}`}
                >
                  <span>{name} Checkout</span>
                  <FaArrowRight />
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
